import { makeAutoObservable } from 'mobx'
import { MessagesApi } from 'entities/Message/api/messages'
import { type IMessage, type IParamsCreateMessage } from 'entities/Message'
import { ConversationsApi } from 'entities/Conversation'
import { Message } from 'entities/Message/model/Message'
import type { EntitiesStore } from 'entities/EntitiesExport'

export class MessageStore {
  constructor(private _entities: EntitiesStore) {
    makeAutoObservable(this)
  }

  loading = false
  items: IMessage[] = []

  createMessageByConversationId = async (conversationId: number, body: IParamsCreateMessage) => {
    try {
      const { data } = await MessagesApi.createMessage(conversationId, body)
      ConversationsApi.updateByIdRead(conversationId)
      return new Message(
        {
          message: data,
        },
        this._entities
      )
    } catch (e) {
      return null
    }
  }
}
